import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"

const useFetchFilteredPatients = (date, id) => {
	const { getAccessTokenSilently, isAuthenticated } = useAuth0()

	const query = useQuery({
		queryKey: ["filtered-patients", date, id],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER }
			})
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/get-filtered-patients`,
				{
					headers: { Authorization: `Bearer ${token}` },
					params: { date, id }
				}
			)
			return response.data
		},
		enabled: isAuthenticated && !!date && !!id,
		staleTime: 1000 * 60 * 2
	})

	return {
		filteredPatients: query.data ?? [],
		loading: query.isLoading,
		error: query.error
	}
}

export default useFetchFilteredPatients
